<template>
    <div :class="`${rowClass} h-100`">
        <div :class="`${colClass} h-100`">
            <ul>
                <li v-for="p in page.child_pages" :key="p.id">
                    <a :href="p.uri" target="_blank">{{ p.name }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            block: Object,
            page: Object,
        },
        computed: {
            rowClass() {
                return this.block.span_row ? _.getRowClass(this.block) : null
            },
            colClass() {
                return this.block.span_row ? _.getColClass(this.block) : null
            },
        },
        data() {
            return {
                trans: trans,
            }
        },
    }
</script>